import { redirect } from "react-router-dom";

import { deleteProjects } from "@/services/lukita/projects";

export default async function deleteProjectAction({ request }) {
  const formData = await request.formData();
  const slugs = formData.get("slugs");

  await deleteProjects(slugs.split(","));
  return redirect("/?success");
}
